import React, { useState } from "react";
import outline from "../../assets/icons/blogs_page.svg";
import blogs from "./blogdata";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const BlogsAll = () => {
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  // Total pages
  const totalPages = Math.ceil(blogs.length / itemsPerPage);
  // Start & End index
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // Current page items
  const currentBlogs = blogs.slice(startIndex, endIndex);
  // Page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative ">
      <div className="bottom-0  right-0 absolute w-1/2">
        <img src={outline} alt="outline" />
      </div>
      <div data-aos="fade-up" className="xl:w-[1280px] 2xl:px-0 xl:px-10 px-0 w-11/12 mx-auto flex justify-center items-center relative flex-col z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8">
          {currentBlogs.map((blog) => (
            <div
              key={blog.title}
              className="group relative flex flex-col rounded-lg bg-[#E8EDF2] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative overflow-hidden h-56">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                {/* Date */}
                <div className="absolute top-4 left-4 bg-[#1d9e75] backdrop-blur-md text-almond text-sm px-4 py-1 rounded-full">
                  {blog.date}
                </div>
              </div>
              {/* Content */}
              <div className="flex flex-col justify-between flex-1 sm:p-5 p-3">
                <div>
                  <h3 className=" mb-3 line-clamp-2 md:text-xl text-xl font-bold text-matcha">
                    {blog.title}
                  </h3>
                  <p className="text-matcha leading-relaxed mb-3 line-clamp-3">
                    {blog.description}
                  </p>
                </div>
                <Link
                  to={`/blogs/${blog.link}`}
                  className="bg-matcha py-3 w-36 text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-2 rounded-lg hover:bg-transparent hover:text-matcha duration-200 transition"
                >
                  Read More <ArrowRight strokeWidth={1} />
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-center gap-3 mt-10">
          {/* Previous */}
          <button
            onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
            className={`px-2 py-2 text-matcha border border-matcha rounded-lg ${
              currentPage === 1
                ? "opacity-50  cursor-not-allowed"
                : "hover:bg-matcha hover:text-white"
            }`}
          >
            <ChevronLeft />
          </button>
          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, index) => {
            const page = index + 1;

            return (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={`w-10 h-10 rounded-lg border border-matcha font-bold font-quicksand text-matcha transition-all duration-300 ${
                  currentPage === page
                    ? "bg-matcha text-white"
                    : "hover:bg-gray-200"
                }`}
              >
                {page}
              </button>
            );
          })}
          {/* Next */}
          <button
            onClick={() =>
              currentPage < totalPages && handlePageChange(currentPage + 1)
            }
            className={`px-2 py-2 border text-matcha border-matcha rounded-lg ${
              currentPage === totalPages
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-matcha hover:text-white"
            }`}
          >
            <ChevronRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogsAll;
